import { Component, ChangeDetectionStrategy } from "@angular/core";
import { SignupService } from "../../services/signup.service";
import { ToastService } from "../../services/toast.service";
import { MatDialog } from "@angular/material/dialog";
import nameOf from "src/app/shared/form/nameOf.helper";
import {
    ConfirmDialogComponent,
    ConfirmDialogData,
} from "src/app/shared/confirmDialog/confirmDialog.component";
import { Signup } from "src/app/models/signup.model";
import { AuthService } from "src/app/services";
import { TimeZoneService } from "src/app/services/timeZone.service";
import { BaseGridComponent } from "src/app/shared/grid/baseGrid.component";
import { CommonService } from "src/app/services/common.service";
import { GridViewService } from "src/app/services/grid-view.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  standalone: false,
    selector: "app-pre-signup-user-list",
    templateUrl: "./preSignupUserList.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./preSignupUserList.component.scss"],
})
export class PreSignupUserListComponent extends BaseGridComponent<Signup> {
    timeZoneLabel: string;

    constructor(
        protected signupService: SignupService,
        toastService: ToastService,
        authService: AuthService,
        timeZoneService: TimeZoneService,
        dialog: MatDialog,
        commonService: CommonService,
        gridViewService: GridViewService,
        private translateService: TranslateService,
    ) {
        super(toastService, dialog, commonService, gridViewService);
        this.timeZoneLabel = timeZoneService.createTimeZoneLabel(
            authService.getCurrentUser().userTimeZone,
        );
        this.gridService = signupService;
        this.displayedColumns = [
            nameOf<Signup>((x) => x.id),
            nameOf<Signup>((x) => x.status),
            nameOf<Signup>((x) => x.firstName),
            nameOf<Signup>((x) => x.lastName),
            nameOf<Signup>((x) => x.emailId),
            nameOf<Signup>((x) => x.companyName),
            nameOf<Signup>((x) => x.mobileNumber),
            "action",
        ];
    }

    approveUser(selectedUser: Signup) {
        this.isLoading = true;
        this.signupService.approveUser(selectedUser.id).subscribe(
            (response) => {
                this.toastService.showSuccess(
                    this.translateService.instant(
                        "User account has been setup successfully!",
                    ),
                    true,
                );
                this.isLoading = false;
                this.loadPage();
            },
            (error) => {
                this.toastService.showError(
                    error,
                    this.translateService.instant("User account setup failed."),
                );
                this.isLoading = false;
            },
        );
    }

    declineUser(selectedUser: Signup) {
        const data: ConfirmDialogData = {
            title: this.translateService.instant("Decline Signup Request"),
            message: this.translateService.instant(
                "Are you sure you want to decline signup request from {{emailId}}?",
                { emailId: selectedUser.emailId },
            ),
            primaryButtonText: this.translateService.instant("Decline"),
            primaryCallback: () =>
                this.signupService.declineUser(selectedUser.id),
            successMessage: this.translateService.instant(
                "Signup request declined successfully!",
            ),
            secondaryButtonText: this.translateService.instant("Cancel"),
            errorMessage: "",
        };
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data,
            width: "450px",
            disableClose: true,
        });
        this.handleDialogClose(dialogRef);
    }
}
